import { render, staticRenderFns } from "./EditarSenhaAdministradorUnidade.vue?vue&type=template&id=de0618e6"
import script from "./EditarSenhaAdministradorUnidade.vue?vue&type=script&lang=js"
export * from "./EditarSenhaAdministradorUnidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports